<div class="d-flex dialog-header p-2 pl-3">
    <h3>{{ 'departmentCapacity.manageSlots' | translate}}</h3>
    <button class="d-flex ml-auto btn" (click)="close()">
        <asp-icon name="ic-20-utility-close-default.svg" class="d-flex cursor-pointer "></asp-icon>
    </button>
</div>
<div class="px-4 pt-2">
    <span>{{ 'departmentCapacity.shopMaxSlots' | translate}}</span>
    <span class="slot-total-count pl-2">150</span>
</div>
<form [formGroup]="editCapacity">
    <div class="dialog-height">
        <mat-table [dataSource]="timeSlots" class="alternateColor px-4 pb-2 mx-auto">

            <ng-container matColumnDef="slot">
                <mat-header-cell *matHeaderCellDef class="justify-content-center "> </mat-header-cell>
                <mat-cell *matCellDef="let element" class="">{{element.text}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="totalSlot">
                <mat-header-cell *matHeaderCellDef class="justify-content-center">{{ 'departmentCapacity.teamWiseTotal' | translate}}</mat-header-cell>
                <mat-cell *matCellDef> </mat-cell>
            </ng-container>

            <ng-container *ngFor="let col of teams" [matColumnDef]="''+col.id">
                <mat-header-cell *matHeaderCellDef class="justify-content-center"> {{col.name}}</mat-header-cell>
                <mat-cell *matCellDef="let element" class="justify-content-center">
                    <input type="number" min="0" class=" form-control m-2" />
                </mat-cell>
            </ng-container>

            <ng-container *ngFor="let col of teams" [matColumnDef]="'total'+col.id">
                <mat-header-cell *matHeaderCellDef class="justify-content-center">0</mat-header-cell>
                <mat-cell *matCellDef class="justify-content-center">{{ 'departmentCapacity.test' | translate}}</mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayColumns; sticky: true;"></mat-header-row>
            <mat-header-row *matHeaderRowDef="displayTotalColumns; sticky: true;" class="totals-row">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: displayColumns;"></mat-row>
        </mat-table>
    </div>
</form>
<div class="d-flex mt-2 mx-4 mb-4">
    <button mat-stroked-button class="asp-btn-width asp-btn-secondary ml-auto" (click)="close()">{{ 'overrideCapacity.cancel' | translate }}</button>
    <button mat-stroked-button class="asp-btn-width asp-btn-primary ml-2" (click)="saveOverrideDetails()">{{ 'overrideCapacity.save' | translate }}</button>
</div>
